
import React from 'react';
import { Heart } from 'lucide-react';

interface FavoriteButtonProps {
  onFavorite: () => void;
  isFavorite: boolean;
  baseButton: string;
  accentGlow: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export default function FavoriteButton({
  onFavorite,
  isFavorite,
  baseButton,
  accentGlow,
  disabled = false,
  isLoading = false,
}: FavoriteButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (disabled || isLoading) return;
    console.log('FavoriteButton clicked, isFavorite:', isFavorite);
    onFavorite();
  };

  return (
    <button
      type="button" // ✅ Add this
      onClick={handleClick}
      disabled={disabled || isLoading}
      className={`${baseButton} group ${accentGlow} ${
        isFavorite
          ? "bg-red-500/15 border-red-500/30 text-red-500 ring-2 ring-red-500/30 shadow-[0_8px_36px_0_rgba(220,38,38,0.14)] hover:bg-red-500/25 hover:ring-red-500/40"
          : "hover:bg-gold/10 hover:text-gold ring-gold/15"
      } active:scale-95 ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      tabIndex={0}
      aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
      style={{ touchAction: 'manipulation' }}
    >
      <Heart
        size={20}
        className={`${isFavorite ? 'fill-red-500 text-red-500' : ''} ${isLoading ? 'animate-pulse' : ''}`}
      />
    </button>
  );
}
